/*
 * Public API Surface of inventory
 */

export * from './lib/components/inventory.component';
export * from './lib/services/inventory.service';
export * from './lib/inventory.module';
